export function selectPermissions(state) {
  if (!state?.auth) return []
  if (Array.isArray(state.auth.permissions) && state.auth.permissions.length) return state.auth.permissions
  return state.auth.admin?.permissions ?? []
}

/**
 * @param {string[]} permissions
 * @param {string} need
 */
export function can(permissions, need) {
  if (!need) return true
  if (!Array.isArray(permissions) || permissions.length === 0) return false
  if (permissions.includes('*')) return true
  return permissions.includes(need)
}
